import React, { useEffect, useState } from 'react'
import { getOrders, Baseurl, updateOrderData, orderDetails, getAllBoys } from '../../../service/apiService';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select'
import { Button } from 'primereact/button';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Calendar } from 'primereact/calendar';
import './Orders.scss'


const Orders = () => {
  const [datas,setDatas] = useState([])
  const [alldelivboys,setAlldelivboys] = useState([])
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    'userid.firstname': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'adress': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'totalprice': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'paymentMethod': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'status': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    products: { value: null, matchMode: FilterMatchMode.CUSTOM },

});
const [loading, setLoading] = useState(true);
const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [deliveropt,setDeliveropt] = useState() 
  const [deliveryboy,setDeliveryboy] = useState()
  const [parcelgent,setParcelagent] = useState()
  const [prodstatus,setProdstatus] = useState()   
  const [productId,setProductId] = useState() 
  const [trackdet,setTrackDet] = useState()   
  const [date,setDate] = useState()
    const [show, setShow] = useState(false);
      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);

      const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const customProductFilter = (value, filter) => {
      if (!value || !Array.isArray(value) || !filter) {
        return false;
      }
  
      return value.some((product) => {
        if (product && product.name) {
          return product.name.toLowerCase().startsWith(filter.toLowerCase());
        }
        return false;
      });
    };

    const renderHeader = () => {
      return (
          <div className="d-flex justify-content-end">
              <IconField iconPosition="left">
                  <InputIcon className="pi pi-search" />
                  <InputText   className="p-inputtext-sm"
                    style={{ backgroundColor: '#333', color: 'white' }} value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
              </IconField>
          </div>
      );
  };

  const header = renderHeader();

  const init = async () => {
    let orders = await getOrders()
    setDatas(orders.data.data)
    let testData = orders.data.data.map((item,index) => ({...item, id:index+1}))
    setLoading(false);
   let boys = await getAllBoys() 
   let optionValue = boys?.data?.data?.map((itm) => ({value: itm?.name, label: itm?.name}))
   setAlldelivboys(optionValue)
  }

  const TableClicked = (e) => {
console.log(e,'hhhhhhhhhh');

  }

  useEffect(() => {
    ( async () => {
      await init()
     }
 )()
  },[])

  const deliveryOptions = [
    { value: 'parcel', label: 'Parcel Service' },
    { value: 'boy', label: 'Delivery Boy' }
  ]

  // const deliveryBoyOptions = [
  //   { value: 'tom', label: 'Tom' },
  //   { value: 'jerry', label: 'Jerry' }
  // ]

 const deliveryBoyOptions =  alldelivboys

  const deliveryParcelOptions = [
    { value: 'speedCart', label: 'Speed Cart' },
    { value: 'speedPost', label: 'Speed Post' }
  ]

  const deliveryProductStatus = [
    { value: 'pending', label: 'Pending' },
    { value: 'shiping', label: 'Shiping' },
    { value: 'ofd', label: 'Out For Delivery' },
    { value: 'delivered', label: 'Delivered' }
  ]

  const deliveryOptionsChange  = (option) => {
    setDeliveropt(option)
  } 
  const deliveryBoyOptionsChange  = (option) => {
    setDeliveryboy(option)
    setParcelagent(null)
  } 
  const deliveryParcelOptionsChange  = (option) => {
    setParcelagent(option)
    setDeliveryboy(null)
  } 

  const ProductStatusChange  = (option) => {
    setProdstatus(option)
  }


  const cliked = async (id) => {
    let result = await orderDetails(id)
    setDeliveropt(null);setParcelagent(null);setTrackDet(null);
    setProdstatus(null);setDate(null);setDeliveryboy(null)
    console.log(result," hghhh",result?.data?.data?.deliverMethod);
    if(result?.data?.data?.deliverMethod){
      let item = deliveryOptions.find((itm) => itm.value === result?.data?.data?.deliverMethod)
       setDeliveropt(item)
    }
    if(result?.data?.data?.deliveryAgent){
      let item = deliveryParcelOptions.find((itm) => itm.value === result?.data?.data?.deliveryAgent)
      setParcelagent(item)
    }
    if(result?.data?.data?.trackDetail){
      setTrackDet(result?.data?.data?.trackDetail)
    }
    if(result?.data?.data?.OrderStatus){
      let item = deliveryProductStatus.find((itm) => itm.value === result?.data?.data?.OrderStatus)
      setProdstatus(item)
    }
    if(result?.data?.data?.orderDeliveryDate){
      setDate(new Date(result?.data?.data?.orderDeliveryDate))
    } 
    if(result?.data?.data?.deliveryBoyName){
      let item = deliveryBoyOptions.find((itm) => itm.value === result?.data?.data?.deliveryBoyName)
      setDeliveryboy(item)
    } 
    setProductId(id)
    handleShow() 
  }

  const Exportcsv = (item) => {
console.log(item,'itm');
let orderfile = []
orderfile.push(item)
const header = ['createdAt','OrderStatus','adress','mobile','paymentMethod','status','totalprice','User',];
const extractData = (item) => {
  return [    
    item?.createdAt,
    item?.OrderStatus,
    item?.adress,
    item?.mobile,
    item?.paymentMethod,
    item?.status || 'Processing',
    item?.totalprice,
    item?.userid?.firstname+''+item?.userid?.lastname,  
  ]
}
const csvData = [header, ...orderfile.map(extractData)]
const csvContent = csvData.map(row => row.join(',')).join('\n')
const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
const link = document.createElement('a')
link.href = URL.createObjectURL(blob)
link.download = 'orderdetails.csv'
link.click()
  }
  
  const handleSubmit = async (event) => { 
   if(deliveropt.value === 'parcel'){
    let params = {
      deliverMethod: deliveropt.value,
      deliveryAgent: parcelgent.value,
      trackDetail: trackdet,
      OrderStatus: prodstatus.value,
      orderDeliveryDate: date.toISOString()
    }
    await updateOrderData(productId,params)
    handleClose()
    await init()
    setDate(null)
    setDeliveropt(null)
   }
   if(deliveropt.value === 'boy'){
    let params = {
      deliverMethod: deliveropt.value,
      deliveryBoyName: deliveryboy.value,
      OrderStatus: prodstatus.value,
      orderDeliveryDate: date.toISOString()
    }
    await updateOrderData(productId,params)
    handleClose()
    await init()
    setDate(null)
    setDeliveropt(null)
   }
  }
  const customStyles = `
  .p-datatable {
      background-color: #1B1F2A !important
      color: white;
  }
  .p-datatable-header  {
     background-color: #1B1F2A !important;
      color: white;
      border: none !important
  }
   .p-datatable .p-datatable-thead  {
     background-color: #1B1F2A !important;
      color: white;
      border: none
  }
  .p-datatable .p-datatable-thead > tr > th {
      background-color: #1B1F2A;
      color: white;
      border-color: #444;
  }
  .p-datatable .p-datatable-tbody > tr {
      background-color: #1B1F2A;
      color: white;
  }
  .p-datatable .p-datatable-tbody > tr > td {
      border-color: #444;
      color: white;
  }
  .p-datatable .p-datatable-tbody > tr:hover {
      background-color: #333;
  }
  
  /* Paginator styles */
  .p-paginator {
      background-color: #1B1F2A !important;
      color: white !important;
  }
  .p-paginator .p-paginator-page, 
  .p-paginator .p-paginator-next,
  .p-paginator .p-paginator-prev,
  .p-paginator .p-paginator-first,
  .p-paginator .p-paginator-last {
      color: white !important;
  }
  .p-paginator .p-paginator-page.p-highlight {
      background-color: #444;
  }
  
  /* Input field styles */
  .dark-input {
      background-color: #222 !important;
      color: white !important;
      border-color: #444 !important;
  }
  .dark-input::placeholder {
      color: #aaa !important;
  }
  
  /* Dropdown styles */
  .dark-dropdown {
      background-color: #222 !important;
      color: white !important;
      border-color: #444 !important;
  }
  .dark-dropdown .p-dropdown-label {
      color: white !important;
  }
  .dark-dropdown .p-dropdown-trigger {
      background-color: #222 !important;
      color: white !important;
  }
  .p-dropdown-panel {
      background-color: #222 !important;
      border-color: #444 !important;
  }
  .p-dropdown-items-wrapper {
      background-color: #222 !important;
  }
  .p-dropdown-item {
      color: white !important;
  }
  .p-dropdown-item:hover {
      background-color: #444 !important;
  }
  .p-dropdown-item.p-highlight {
      background-color: #555 !important;
  }
  
  /* Sort icon styles */
  .pi-sort, .pi-sort-amount-up-alt, .pi-sort-amount-down {
      color: white !important;
  }
  
  /* Empty message */
  .p-datatable .p-datatable-tbody > tr.p-datatable-emptymessage > td {
      color: white;
  }
`;

const statusBodyTemplate = (rowData) => {
  const style = {
      color: rowData.status === 'cancelled' ? 'red' : 'white'
  };
  return <span style={style}>{rowData.status}</span>;
};


  return (
    <div>
      <div className="right-content" >
                                <div class="page-head d-flex justify-content-between align-items-center flex-wrap">
                                 <h1>MANAGE ORDERS</h1> 
                                 <div> 
                                  {/* <button className="tb-add-btn" data-bs-toggle="modal" data-bs-target="#add-product" onClick={handleShow}>Add Products+</button> */}
                                 </div>
                               </div>
                            
     <div style={{ backgroundColor: '#1B1F2A', padding: '1rem' }}>
     <style>{customStyles}</style>
       <DataTable className='z-index-n1'  value={datas} paginator rows={10} dataKey="_id" filters={filters} filterDisplay="row" loading={loading} 
       globalFilterFields={['userid.firstname', 'adress', 'paymentMethod', 'products']} header={header} emptyMessage="No Data found." style={{ color: 'white' }} >
       <Column field="userid.firstname" header="Name" body={(rowData) => (
        <span>{`${rowData?.userid?.firstname} ${rowData?.userid?.lastname}`}</span>)} filter filterPlaceholder="Search by name" style={{ minWidth: '12rem' }}  />
        <Column field="adress" header="Adress" filter filterPlaceholder="Search by Adress" style={{ minWidth: '12rem' }} />
        <Column field="totalprice" header="Final Amount" filter filterPlaceholder="Search by Amount" style={{ minWidth: '12rem' }} />
        <Column field="status" header="Order Status" filter filterPlaceholder="Search" style={{ minWidth: '12rem' }} body={statusBodyTemplate} />     
        <Column field="OrderStatus" header="DeliverStatus" filter filterPlaceholder="Search" style={{ minWidth: '12rem' }}  />  
        <Column field="paymentMethod" header="Payment Type" filter filterPlaceholder="Search by Type" style={{ minWidth: '12rem' }} />
        <Column field="products" header="Product Details" body={(rowData) => (
    <span>
      {rowData.products && Array.isArray(rowData.products)
        ? rowData.products.map((product) => product?.name).join(', ')
        : rowData.products?.name || 'N/A'}
    </span>)} style={{ minWidth: '12rem' }}  />

    <Column field="Actions" header="Actions" body={(rowData) => (
    <span>
    <Button label='Actions' disabled={rowData?.status === 'cancelled'} onClick={() => {cliked(rowData._id)}}/>
    </span>)} style={{ minWidth: '12rem' }}  />

    <Column field="csv" header="Export CSV" body={(rowData) => (
    <span>
    <Button label='csv' onClick={() => {Exportcsv(rowData)}}/>
    </span>)} style={{ minWidth: '12rem' }}  />

       </DataTable> </div>

                               {/* <div class="container-fluid p-0">
                                   <div class="card">
                                     <div class="table-responsive cmn-table dragscroll">
                                     <div className='text-white'>{isModalOpen ? <Deletemodal isModalOpen={isModalOpen} deleteid={deleteid} closeModal={handleDeleteModal} afterProductDelete={afterProductDelete} proddelete={'proddelete'} /> : <></>}</div> 
                                     <table class="w-100">
                                         <thead className='text-white'>
                                          <tr>  
                                          <th>No.</th>   
                                          <th>Customer Name</th>   
                                          <th>Address</th>   
                                          <th>Price.</th>     
                                          <th>Payment</th>
                                          <th>Products</th>
                                          <th></th>
                                          <th>Edit</th>
                                          <th>Delete</th>
                                          <th width="200"></th>     
                                         </tr>
                                         </thead>
                                         <tbody>
                                         {
                                          datas.map((item,index) => {
                                                return (
                                                    <tr key={item._id} className='text-white'>
                                                    <td>{index+1}</td>
                                                   <td>{item?.userid?.username}</td>
                                                    <td>{item?.adress}</td>
                                                    <td>{item?.totalprice  }</td>
                                                    <td>{item?.paymentMethod}</td>
                                                    {item.products.map((item,index) => {
                                                  return(
                                                    <td> {item.name} <div className='d-flex' key={index}> <img style={{width:'50px',height:'50px'}}  src={`${Baseurl}/view/imageupload/${item.img}`} /> </div> </td>
                                                  )
                                                })}
                                                <td></td>
                                                <td></td>
                                  
                                                    <td class="text-end">
                                                    <button class="act-btns" data-bs-toggle="modal" data-bs-target="#add-client"><i class="far fa-edit"></i> Edit</button>  </td>
                                                    <td class="text-end"><button  class="act-btns"  data-bs-toggle="modal" data-bs-target="#block"><i class="far fa-ban"></i> Delete</button> </td>
                                                    onClick={() => {handleProductDelete(item._id)}}
                                                    </tr>
                                                )
                                            } )
                                         }
                                      
                                             
                                         </tbody>
                                        </table>
    
                                        </div>
                        
                                   </div> 

                               </div>   */}
                            </div>

                            { show ? <Modal className='modal ordermodal position-absolute dark-modal profile-edit fade' show={show} onHide={handleClose}>
                                    <Modal.Header closeButton className='border-0'>
                                      <Modal.Title className='text-white'>UPDATE ORDER DETAILS</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <div className="cm-form">
                                        <label>How to deliver this order</label>
                                        <Select value={deliveropt} options={deliveryOptions} onChange={deliveryOptionsChange}/>
                                        {deliveropt?.value === "boy" ? <div>
                                        <label>Select DeliveryBoy</label>
                                        <Select value={deliveryboy} options={deliveryBoyOptions} onChange={deliveryBoyOptionsChange}/> </div>  : <></> }

                                         {deliveropt?.value === "parcel" ? <div>
                                          <label>Select DeliveryAgent</label>
                                        <Select value={parcelgent} options={deliveryParcelOptions} onChange={deliveryParcelOptionsChange}/> 
                                       
                                          <label>Enter TrackingDetails</label>
                                        <input type="text" value={trackdet} className="form-control" onChange={(e) => setTrackDet(e.target.value)} /> </div> : <></> }
                                        <label>Product Delivering Status</label>
                                        <Select value={prodstatus} options={deliveryProductStatus} onChange={ProductStatusChange}/> 
                                        <div className='mt-5'>
                                        <label>Product DeliverY Date</label>
                                        <Calendar id="buttondisplay" className='ms-5' showTime showSeconds dateFormat="yy-mm-dd" timeFormat="HH:mm:ss" value={date} onChange={(e) => setDate(e.value)} showIcon />
                                        </div>
                                      </div> 
                                    </Modal.Body>
                                    <Modal.Footer className='d-flex justify-content-between border-0'>
                                      <button className='cancel' onClick={handleClose}>
                                        Cancel
                                      </button>
                                      <button type='submit' className='save' onClick={handleSubmit}>
                                        Save
                                      </button>
                                    </Modal.Footer>
                                  </Modal> : <></>}

      
    </div>
  )
}

export default Orders
